export enum AttrCode {
  BANNERIMG = 'BANNERIMG',
  BIGBANNERIMG = 'BIGBANNERIMG',
  OUTLETIMG = 'OUTLETIMG',
  PRODIMG = 'PRODIMG',
}
